import { render } from "./ChatConversationList.vue?vue&type=template&id=285dcafd&scoped=true"
import script from "./ChatConversationList.vue?vue&type=script&lang=js"
export * from "./ChatConversationList.vue?vue&type=script&lang=js"

import "./ChatConversationList.vue?vue&type=style&index=0&id=285dcafd&scoped=true&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285dcafd"]])

export default __exports__